// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDashboardOutlinedSvg from "@fishx/icons-svg/es/asn/PDashboardOutlined";
import FishxIcon from '../components/FishxIcon';

var PDashboardOutlined = function PDashboardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDashboardOutlinedSvg
  }));
};

PDashboardOutlined.displayName = 'PDashboardOutlined';
export default React.forwardRef(PDashboardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDashboardOutlined.js
// module id = 3324
// module chunks = 0